import React from 'react'
import styled from 'styled-components';
import Tag from 'components/Tag';
import COLOR from 'utils/constants/color';
import starNoteSvg from "../../../utils/assets/images/star-note.svg";

const Note = styled.span`
    color: ${COLOR.black400};
`;
export default function NoteMark({note}) {
    if(!note) return(<></>)
    return (
        <div className='assimentSecudleDate'>
            <Tag height={20}><img src={starNoteSvg} alt="NOTE" title="NOTE" /> <label>Note</label></Tag>
            <Note>{note}</Note>
        </div>
    )
}
